import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Permissions',
    name: 'permissions',
    type: FIELD_TYPES.PERMISSIONS_LIST,
    defaultValue: [],
  },
]
